import React from "react";
import { Link } from "react-router-dom";
import { PageLayout } from "./PageLayout";
import { ServiceAreaMap } from "../components/ServiceAreaMap";
import { faqs } from "../mock";
import { ChevronDown } from "lucide-react";

const allItems = faqs;

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: allItems.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqPage() {
  return (
    <PageLayout
      path="/faq"
      eyebrow="FAQ"
      title="Häufige Fragen zur Hausverwaltung"
      intro="Die wichtigsten Antworten rund um WEG-Verwaltung, Kosten, Verwalterwechsel und Erreichbarkeit. Ihre Frage ist nicht dabei? Rufen Sie uns an oder schreiben Sie uns."
      testId="faq-page"
    >
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="space-y-3" data-testid="faq-page-list">
        {allItems.map((f, i) => (
          <details
            key={f.q}
            open={i === 0}
            data-testid={`faq-item-${i}`}
            className="group bg-white rounded-2xl border border-brand-100 px-6 open:shadow-md transition-shadow"
          >
            <summary className="flex items-center justify-between gap-4 cursor-pointer list-none py-5 font-display font-semibold text-brand-900 [&::-webkit-details-marker]:hidden">
              <h2 className="text-base md:text-lg font-semibold">{f.q}</h2>
              <ChevronDown className="w-4 h-4 shrink-0 text-brand-500 transition-transform duration-200 group-open:rotate-180" />
            </summary>
            <div className="text-brand-700 leading-relaxed pb-5">
              {f.a}
              {f.link && (
                <div className="mt-3">
                  <Link to={f.link.to} className="underline text-brand-900 font-medium">
                    {f.link.label}
                  </Link>
                </div>
              )}
              {f.map && <ServiceAreaMap />}
            </div>
          </details>
        ))}
      </div>
    </PageLayout>
  );
}
